import { useEffect, useState } from "react";

// Para cajas de búsqueda: el listado solo se vuelve a pedir al servidor cuando el usuario deja de
// teclear, no en cada pulsación.
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
